// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* body {
  overflow: hidden;
} */
.body_W09Mg {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100vh;
  overflow-y: scroll;
  /* &::-webkit-scrollbar {
    display: none;
  } */
}

.container_DfXxs {
  display: flex;
  /* height: calc(100vh - 50px); */
  height: 100vh;
  margin: 0;
  padding: 0;
  font-family: "Inter", serif;
  position: relative;
  width: 100%;
  /* overflow-y: auto; */
  /* overflow: hidden; */
  margin-top: 0px;
  background-color: var(--f5-background);
  color: var(--black-color);
}
.contentTemplate_f1Dbu {
  box-sizing: border-box;
  display: flex;
  min-width: 0;
  width: 100%;
  /* width: calc(100% - 200px); */
  height: 100%;
  border-radius: 20px 0 0 0 !important;
  background: var(--white-background);
  gap: 2px;
  transition: border-radius 0.5s ease-in-out;
  overflow-y: auto;
  overflow-x: hidden;
  position: relative;

  &.isAtBottom_gjD7x {
    border-radius: 0px 0 0 0 !important;
  }
}
@media (width<=768px) {
  .contentTemplate_f1Dbu {
    position: absolute;
    width: 100vw;
  }
}
.inputContainer_ZxwMb input[type="file"] {
  display: none;
}

.inputContainer_ZxwMb {
  width: 100%;
}

.inputContainer_ZxwMb label {
  height: 100%;
  width: 100%;
  color: var(--_646e8a-color);
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
}

.mobileMenuOverlay_GfQc6 {
  position: none;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: var(--_FFFFFF80-background) ;
  z-index: 998;
}

.mobileMenu_ylaMZ {
  z-index: 999;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 10px;
  position: fixed;
  top: 0px;
  left: -100vw;
  width: 240px;
  background-color: var(--white-background);
  z-index: 1000;
  height: 100vh;
  transition: left 300ms;
  padding: 10px;
  border-left: 1px solid var(--f5-border);
  -webkit-transition: left 300ms;
  -moz-transition: left 300ms;
  -ms-transition: left 300ms;
  -o-transition: left 300ms;
  button {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;

    svg {
      width: 20px;
      height: 20px;
    }
  }

  ul {
    display: flex;
    flex-direction: column;
    align-items: start;
    justify-content: start;
    gap: 30px;
    width: 100%;
    box-sizing: border-box;
    margin: 0;
    padding: 10px;
    height: 100%;

    li,
    a {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 10px;
      text-decoration: none;
      color: var(--_2-color);

      svg {
        width: 20px;
        height: 20px;
      }
    }
  }

  .profileContainer_PCdky {
    align-items: flex-end;
    display: flex;
    align-items: center;
    gap: 10px;
      @media (width<=950px) {
    display: none;
  }
    p {
      font-size: 15px;
      margin: 0;
    }
    span {
      font-size: 10px;
    }
    .initials_Xooqq {
      width: 40px;
      height: 40px;
      min-width: 40px;
      border-radius: 5px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: var(--_16c098-background);
      color: var(--white-color);
      font-size: 20px;
      font-weight: 600;
    }
  }
}

@media screen and (max-width: 768px) {
  .hiddenMobile_r5iAR {
    display: none;
  }
}
.activeMenuOverlay_Xp9HU {
  position: fixed;
}
.activeMobileMenu_xx2u2 {
  left: 0;
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/PanelTemplate/PanelTemplate.module.css"],"names":[],"mappings":"AAEA;;GAEG;AACH;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB;;KAEG;AACL;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,aAAa;EACb,SAAS;EACT,UAAU;EACV,2BAA2B;EAC3B,kBAAkB;EAClB,WAAW;EACX,sBAAsB;EACtB,sBAAsB;EACtB,eAAe;EACf,sCAAsC;EACtC,yBAAyB;AAC3B;AACA;EACE,sBAAsB;EACtB,aAAa;EACb,YAAY;EACZ,WAAW;EACX,+BAA+B;EAC/B,YAAY;EACZ,oCAAoC;EACpC,mCAAmC;EACnC,QAAQ;EACR,0CAA0C;EAC1C,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;;EAElB;IACE,mCAAmC;EACrC;AACF;AACA;EACE;IACE,kBAAkB;IAClB,YAAY;EACd;AACF;AACA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,2BAA2B;EAC3B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8CAA8C;EAC9C,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,SAAS;EACT,eAAe;EACf,QAAQ;EACR,YAAY;EACZ,YAAY;EACZ,yCAAyC;EACzC,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,uCAAuC;EACvC,8BAA8B;EAC9B,2BAA2B;EAC3B,0BAA0B;EAC1B,yBAAyB;EACzB;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;;IAET;MACE,WAAW;MACX,YAAY;IACd;EACF;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,sBAAsB;IACtB,SAAS;IACT,WAAW;IACX,sBAAsB;IACtB,SAAS;IACT,aAAa;IACb,YAAY;;IAEZ;;MAEE,aAAa;MACb,mBAAmB;MACnB,uBAAuB;MACvB,SAAS;MACT,qBAAqB;MACrB,sBAAsB;;MAEtB;QACE,WAAW;QACX,YAAY;MACd;IACF;EACF;;EAEA;IACE,qBAAqB;IACrB,aAAa;IACb,mBAAmB;IACnB,SAAS;MACP;IACF,aAAa;EACf;IACE;MACE,eAAe;MACf,SAAS;IACX;IACA;MACE,eAAe;IACjB;IACA;MACE,WAAW;MACX,YAAY;MACZ,eAAe;MACf,kBAAkB;MAClB,aAAa;MACb,mBAAmB;MACnB,uBAAuB;MACvB,qCAAqC;MACrC,yBAAyB;MACzB,eAAe;MACf,gBAAgB;IAClB;EACF;AACF;;AAEA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE,eAAe;AACjB;AACA;EACE,OAAO;AACT","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap\");\n\n/* body {\n  overflow: hidden;\n} */\n.body {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  height: 100vh;\n  overflow-y: scroll;\n  /* &::-webkit-scrollbar {\n    display: none;\n  } */\n}\n\n.container {\n  display: flex;\n  /* height: calc(100vh - 50px); */\n  height: 100vh;\n  margin: 0;\n  padding: 0;\n  font-family: \"Inter\", serif;\n  position: relative;\n  width: 100%;\n  /* overflow-y: auto; */\n  /* overflow: hidden; */\n  margin-top: 0px;\n  background-color: var(--f5-background);\n  color: var(--black-color);\n}\n.contentTemplate {\n  box-sizing: border-box;\n  display: flex;\n  min-width: 0;\n  width: 100%;\n  /* width: calc(100% - 200px); */\n  height: 100%;\n  border-radius: 20px 0 0 0 !important;\n  background: var(--white-background);\n  gap: 2px;\n  transition: border-radius 0.5s ease-in-out;\n  overflow-y: auto;\n  overflow-x: hidden;\n  position: relative;\n\n  &.isAtBottom {\n    border-radius: 0px 0 0 0 !important;\n  }\n}\n@media (width<=768px) {\n  .contentTemplate {\n    position: absolute;\n    width: 100vw;\n  }\n}\n.inputContainer input[type=\"file\"] {\n  display: none;\n}\n\n.inputContainer {\n  width: 100%;\n}\n\n.inputContainer label {\n  height: 100%;\n  width: 100%;\n  color: var(--_646e8a-color);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n}\n\n.mobileMenuOverlay {\n  position: none;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: var(--_FFFFFF80-background) ;\n  z-index: 998;\n}\n\n.mobileMenu {\n  z-index: 999;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n  gap: 10px;\n  position: fixed;\n  top: 0px;\n  left: -100vw;\n  width: 240px;\n  background-color: var(--white-background);\n  z-index: 1000;\n  height: 100vh;\n  transition: left 300ms;\n  padding: 10px;\n  border-left: 1px solid var(--f5-border);\n  -webkit-transition: left 300ms;\n  -moz-transition: left 300ms;\n  -ms-transition: left 300ms;\n  -o-transition: left 300ms;\n  button {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 10px;\n\n    svg {\n      width: 20px;\n      height: 20px;\n    }\n  }\n\n  ul {\n    display: flex;\n    flex-direction: column;\n    align-items: start;\n    justify-content: start;\n    gap: 30px;\n    width: 100%;\n    box-sizing: border-box;\n    margin: 0;\n    padding: 10px;\n    height: 100%;\n\n    li,\n    a {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      gap: 10px;\n      text-decoration: none;\n      color: var(--_2-color);\n\n      svg {\n        width: 20px;\n        height: 20px;\n      }\n    }\n  }\n\n  .profileContainer {\n    align-items: flex-end;\n    display: flex;\n    align-items: center;\n    gap: 10px;\n      @media (width<=950px) {\n    display: none;\n  }\n    p {\n      font-size: 15px;\n      margin: 0;\n    }\n    span {\n      font-size: 10px;\n    }\n    .initials {\n      width: 40px;\n      height: 40px;\n      min-width: 40px;\n      border-radius: 5px;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      background: var(--_16c098-background);\n      color: var(--white-color);\n      font-size: 20px;\n      font-weight: 600;\n    }\n  }\n}\n\n@media screen and (max-width: 768px) {\n  .hiddenMobile {\n    display: none;\n  }\n}\n.activeMenuOverlay {\n  position: fixed;\n}\n.activeMobileMenu {\n  left: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"body": `body_W09Mg`,
	"container": `container_DfXxs`,
	"contentTemplate": `contentTemplate_f1Dbu`,
	"isAtBottom": `isAtBottom_gjD7x`,
	"inputContainer": `inputContainer_ZxwMb`,
	"mobileMenuOverlay": `mobileMenuOverlay_GfQc6`,
	"mobileMenu": `mobileMenu_ylaMZ`,
	"profileContainer": `profileContainer_PCdky`,
	"initials": `initials_Xooqq`,
	"hiddenMobile": `hiddenMobile_r5iAR`,
	"activeMenuOverlay": `activeMenuOverlay_Xp9HU`,
	"activeMobileMenu": `activeMobileMenu_xx2u2`
};
export default ___CSS_LOADER_EXPORT___;
